export default __webpack_public_path__ + "static/media/contactHero.4982778e.jpg";